import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { setFinanceBackMoneyStatus } from '@/api/financial-center'
import { Loading } from 'element-ui'
import * as math from 'mathjs'
@Component({})
export default class BackMoneyStudentInfo extends Vue {
    logShow = true
    backMoneyId = NaN
    backMoneyInfo: any = ''
    type = ''

    cancleReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    status: number = null // 提交时候用到的状态
    reviewStatus: string = null //审批状态
    editFileList = []
    editFiles = {
        account: null,
        payAccount: null, // 付款账户
        backMoneyAt: null,
        financeBackMoneyProofList: null
    }
    isRequired = false
    previewVisible = false
    previewPath = ''
    disBtn = false
    fileList: { name: string; url: string; uid?: number }[] = []
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    previewName = ''
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回

    get orderAllPrice() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item =>
        {
            num = math.number(math.add(math.bignumber(num),math.bignumber( Number(item.price))))
        }
        )
        return num
    }

    get needBackMoney() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
            num = math.number(math.add(math.bignumber(num),math.bignumber(Number(item.needBackMoney))))
            }
        )
        return num
    }

    get thisBackMoney() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item =>{
            num = math.number(math.add(math.bignumber(num),math.bignumber(Number(item.thisTimePrice))))
            }
        )
        return num
    }

    get elImageUrls() {
        return this.backMoneyInfo ? this.backMoneyInfo.financeBackMoneyProofList.map(item => item.url): []
    }
    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        this.backMoneyId = Number(this.$route.query.id)
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getFinanceBackMoneyById()
        this.type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string
    }

    formatDate = formatDate
    async getFinanceBackMoneyById() {
        const data: any = await getMessageReviewById(this.backMoneyId,this.types)
        this.backMoneyInfo = data.result
        this.editFileList = this.backMoneyInfo.editFileList
        this.editFileList && this.editFileList.forEach(item => {
            this.editFiles[item.file] = this.backMoneyInfo[item.file]
        })
        this.fileList = this.backMoneyInfo.financeBackMoneyProofList
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.stepNode.isFirstNode = this.backMoneyInfo.isFirstNode
        this.stepNode.isSyncEkuaibao = this.backMoneyInfo.isSyncEkuaibao
        this.stepNode.isSyncEqianbao = this.backMoneyInfo.isSyncEqianbao
    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        if(this.editFileList != undefined && this.editFileList != null){
            return this.editFileList.some(item => item.file === key)
        }
    }

    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    // 撤回审批
    async cancleReviewDialogConfirm() {
        await setFinanceBackMoneyStatus({ id: this.backMoneyInfo.id, action: '1' })
        this.$message.success('成功撤回审批')
        setTimeout(() => { window.close() }, 1500)
    }

    openReviewDialog(status: number) {
        this.status = status
        this.approvedVisible = true
    }

    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    reviewDialogConfirm() {
        const newObj = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) {
                delete newObj[key]
            }
        }
        if(this.isRequired && this.status === 1) {
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    this.$message.error('请将编辑的信息填写完整')
                    break;
                }
            }
        }
        const obj = {
            messageReviewId: this.backMoneyId,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {},
            nodeType: this.nodeType,
        }
        this.disBtn = true
        const loading = Loading.service({
            text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
        })
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.status === 1 ? '审批通过' : '审批驳回')
            loading.close()
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
            this.disBtn = false
        })
    }
    // 通过
    async approvedConfirm() {

        let flag = true
        const newObj = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) {
                delete newObj[key]
            }
        }
        if(this.isRequired && this.status === 1) {
            for(const key in newObj) {
                if(!newObj[key] || (newObj[key].length === 0)) {
                    this.$message.error('请将编辑的信息填写完整')
                   flag = false
                }
            }
        }
        const obj = {
            messageReviewId: this.backMoneyId,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {},
            isRevoke: this.isAgreeRevoke
        }

        if (flag) {
            this.disBtn = true
            const loading = Loading.service({
                text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
            })
            await setMessageReviewUserByMessageReviewId(obj).then(() => {
                this.$message.success(this.status === 1 ? '审批通过' : '审批驳回')
                loading.close()
                setTimeout(() => {
                    window.close()
                }, 1500)
            }).catch((err: Error) => {
                this.disBtn = false
            })
        }
    }

    // 驳回审批
    clickRejectButton(status: number) {
        // this.stepNode.approvalStatus = status
        this.status = status
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        this.nodeType = data.rejectNode
        this.opinion = data.reviewIdea
        this.approvalVisible = false
        this.reviewDialogConfirm()
    }

    /*
  * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.opinion = data.reviewIdea
        this.isAgreeRevoke = data.isAgreeRevoke
        this.approvedVisible = false
        this.approvedConfirm()
    }
}
